import { Link, styled } from '@mui/material';

export const LinkStyled = styled(Link)`
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
`;
export const LinkDangerStyled = styled(Link)`
  color: ${({ theme }) => theme.vars.palette.error.main};
  transition: transform 0.3s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.vars.palette.error.main};
    transform: scale(1.1);
  }
`;
